import React, { Component } from 'react';
import { FormGroup, ControlLabel, FormControl } from 'react-bootstrap';

function FieldGroup({ ...props }) {
    return (
        <FormGroup>
            <ControlLabel>{props.label}</ControlLabel>
            <FieldControl {...props} />
        </FormGroup>
    );
}
function FieldControl({error, onChange, tabName, ...props}) {
  if (props.type === 'multiplechoice' || props.type === 'select') {
    return (
      <FormControl disabled={props.disabled}
        componentClass="select" multiple={props.multiple} defaultValue={props.defaultValue}
        onChange = {(event) => onChange(event, props.name, tabName, props.type)}
        placeholder={props.name} name={props.name}>
        {
           props.options.map((option, index) => {
              return (<option key={index} value={option.value}>{option.label}</option>)
           })
        }
      </FormControl>
    )
  }
  return (
    <div>
      <FormControl {...props} onChange = {(event) => onChange(event, props.name, tabName, props.type)} />
      {error.error && error.message}
    </div>
  )
}

export class FormInputs extends Component{
    render(){
        var row = [];
        for(var i = 0; i < this.props.ncols.length ; i++){
            row.push(
                <div key={i} className={this.props.ncols[i]}>
                    <FieldGroup
                        {...this.props.properties[i]}
                    />
                </div>
            );
        }
        return (
            <div className="row">
                {row}
            </div>
        );
    }
}

export default FormInputs;



// WEBPACK FOOTER //
// ./src/components/FormInputs/FormInputs.jsx